import { render, staticRenderFns } from "./Donate.vue?vue&type=template&id=4982fe22&"
import script from "./Donate.vue?vue&type=script&lang=js&"
export * from "./Donate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports